// extracted by mini-css-extract-plugin
module.exports = {"group":"style_group__245lM","radio-check":"style_radio-check__3SxQ3"};